import { render, staticRenderFns } from "./DefaultProductSet.vue?vue&type=template&id=51d519bf"
import script from "./DefaultProductSet.vue?vue&type=script&lang=ts"
export * from "./DefaultProductSet.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports